// @ts-nocheck
import * as actions from './dealerActions';

export { actions };
